/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-23",
    versionChannel: "nightly",
    buildDate: "2025-04-23T00:06:48.721Z",
    commitHash: "f0e71f126ca0a8026dc764746f00ad79eeb3989d",
};
